import { render, staticRenderFns } from "./verdepo.vue?vue&type=template&id=15c53405"
import script from "./verdepo.vue?vue&type=script&lang=js"
export * from "./verdepo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports